import * as jsxRuntime from "C:\\Users\\Eriksen\\Claude udvikling\\eido-bakkebyen\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment